import { Route } from '@/constants';
import type { AvatarDropdownItem } from '@/features/header/components/avatar-dropdown';

export const getNavUserItems = (
    t: (key: string) => string,
    navigate: (route: string) => void
): AvatarDropdownItem[] => [
        {
            label: t('Profile settings'),
            icon: 'person',
            onClick: () => navigate(Route.ProfileSettings),
        },
        {
            label: t('Plans & Billing'),
            icon: 'credit-card',
            onClick: () => navigate(Route.PlanSettings),
        },
        {
            label: t('Company'),
            icon: 'buildings',
            onClick: () => navigate(Route.CompanySettings),
        },
        /* {
            label: t('Team'),
            icon: 'people',
            onClick: () => navigate(Route.TeamSettings),
        }, */
    ];
